<template>
    <b-container v-if="registrationEnabled" fluid="" style="height: 100%">
        <div class="container">
            <b-row>
                <b-col>
                    <b-navbar toggleable="lg" type="dark" variant="custom">
                        <b-navbar-brand>
                            <img :height="brandLogoHeight" :alt="brandAlt" :src="brandLogo">
                        </b-navbar-brand>

                        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

                        <b-collapse  id="nav-collapse" is-nav>
                            <b-navbar-nav class="ml-auto">

                                <b-nav-item-dropdown
                                    :text="getCurrentLang()"
                                    class="registration-language"
                                    :disabled="saving"
                                    right
                                >
                                    <b-dropdown-item
                                        v-for=" lang of langList"
                                        :key="lang.id"
                                        @click="updateLang(lang.id)"
                                    >{{lang.name}}</b-dropdown-item>
                                </b-nav-item-dropdown>
                            </b-navbar-nav>
                        </b-collapse>
                    </b-navbar>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                </b-col>
            </b-row>
        </div>
        <ValidationObserver ref="organisationCreateForm" v-slot="{ invalid }">
    <b-form v-if="!created" @submit.prevent="onSubmit">
      <fieldset :disabled="saving">
    <validation-provider vid="organisationName" v-slot="{ errors }" rules="required|unicodeLength:5,255|userName" >
        <b-form-group
          label-for="organisationName"
          :label="$t('organisation.create.name')"
      >
        <b-input
          id="organisationName"
          v-model="form.organisationName"
          :placeholder="$t('organisation.create.name')"
        >
        </b-input>

        <span class="text-danger">{{ errors[0] }}</span>
      </b-form-group>
      </validation-provider>
    <validation-provider vid="userName" v-slot="{ errors }" rules="required|unicodeLength:5,255|userName" >
        <b-form-group
            label-for="userName"
            :label="$t('user.create.name')"
        >
            <b-input
                id="userName"
                v-model="form.userName"
                :placeholder="$t('user.create.name')"
            >
            </b-input>

            <span class="text-danger">{{ errors[0] }}</span>
        </b-form-group>
    </validation-provider>
    <validation-provider vid="phone" v-slot="{ errors }" rules="required|phone" >
        <b-form-group
            label-for="phone"
            :label="$t('user.create.phone')"
        >
            <b-input
                id="phone"
                v-model="form.phone"
                :placeholder="$t('user.create.phone')"
            >
            </b-input>

            <span class="text-danger">{{ errors[0] }}</span>
        </b-form-group>
    </validation-provider>
    <validation-provider vid="email" v-slot="{ errors }" rules="required|email" >
        <b-form-group
            label-for="email"
            :label="$t('user.create.email')"
        >
            <b-input
                id="email"
                v-model="form.email"
                :placeholder="$t('user.create.email')"
            >
            </b-input>

            <span class="text-danger">{{ errors[0] }}</span>
        </b-form-group>
    </validation-provider>
    <validation-provider vid="password" v-slot="{ errors }" rules="required|min:5|max:255|password" >
            <b-form-group
                label-for="password"
                :label="$t('user.create.password')"
            >
                <b-input
                    id="password"
                    type="password"
                    v-model="form.password"
                    aria-describedby=""
                    :placeholder="$t('user.create.password.placeholder')"
                >
                </b-input>
                <!--        <b-form-text id="password-help-block">-->
                <!--          {{$t('password-help-block')}}-->
                <!--        </b-form-text>-->

                <span class="text-danger">{{ errors[0] }}</span>
            </b-form-group>
        </validation-provider>
    <div v-if="responseError" class="text-danger registration-save-error">
      {{$t('saved_error')}} <br>
      {{responseErrorMessage}}
    </div>
      <b-button
          :disabled="invalid || saving"
          type="submit"
          variant="primary"
      >{{$t('organisation.create')}}</b-button>

      </fieldset>
    </b-form>
    </ValidationObserver>
        <span v-if="created">
        <div>
          {{$t('registration_accepted')}} <router-link to="/login">{{$t('login')}}</router-link>
        </div>
      </span>
    </b-container>
</template>

<script>
import {loadLanguageAsync} from "@/client/i18n";
import { saveForm } from "../../utils/SaveForm";
import { isPublicRegistrationEnabled, isPublicRegistrationValid, publicLanguages } from "../../utils/RegistrationForm";

import {localize} from "vee-validate";

export default {
  name: "Create",
  data() {
    return {
        registrationEnabled: isPublicRegistrationEnabled(),
        defaultLang: process.env.VUE_APP_DEFAULT_LANG,
        brandAlt: process.env.VUE_APP_NAME,
        brandLogo: 'assets/logo/' + process.env.VUE_APP_LOGO,
        brandLogoHeight: process.env.VUE_APP_LOGO_HEIGHT + 'px',
        langList: publicLanguages(process.env.VUE_APP_LANGS, process.env.VUE_APP_DEFAULT_LANG),
        saving: false, disposed: false, requestVersion: 0,
        form: {
            organisationName: null,
            userName: null,
            password: null,
            phone: null,
            email: null,
        },
        responseError: false,
        responseErrorMessage: null,
        created: false
    }
  },
  methods: {
    onSubmit() {
      if (!isPublicRegistrationEnabled() || this.created) return;
      return saveForm(this, { method: 'put', url: 'web/v1/registration', payload: this.form,
        observer: 'organisationCreateForm', success: 'created', event: 'onCreated',
        fields: ['organisationName', 'userName', 'phone', 'email', 'password'], validPayload: isPublicRegistrationValid,
        validResponse: data => data !== null && typeof data === 'object' && data.status === 'success',
      });
    },
    getCurrentLang: function() {
      for (let lng in this.langList) {
          if (this.langList[lng].id === this.lang) {
              return this.langList[lng].name
          }
      }
      return this.langList[0].name;
    },
    updateLang: function (value) {
      if (this.saving || this.disposed || !this.langList.some(item => item.id === value)) return;
      this.$store.commit('selLang', {lang: value})
      loadLanguageAsync(value);
      location.reload();
    },
  },
  beforeDestroy() { this.disposed = true; this.requestVersion++; },
    computed: {
        lang : {
            get() {
                const language = this.$store.getters.getLang || this.defaultLang;
                return this.langList.some(item => item.id === language) ? language : this.langList[0].id;
            },
            set(value) {
                if (this.saving || this.disposed || !this.langList.some(item => item.id === value)) return;
                this.$store.commit('selLang', {lang: value})
                loadLanguageAsync(value)
                localize(value);
            }
        },
    }
}
</script>

<style scoped>

</style>
